import React, {Component} from 'react';
import {
  Container,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

const items = [
  {
    src: '../img/wireframes/1_login_SpaceGrey.png',
    altText: '',
    caption: ''
  }, {
    src: '../img/wireframes/2_feed_Grey.png',
    altText: '',
    caption: ''
  }, {
    src: '../img/wireframes/3_matches_Gold.png',
    altText: '',
    caption: ''
  }, {
    src: '../img/wireframes/3a_matchScoring_SpaceGrey.png',
    altText: '',
    caption: ''
  }, {
    src: '../img/wireframes/3b_matchDetails_Grey.png',
    altText: '',
    caption: ''
  }, {
    src: '../img/wireframes/4_league_Gold.png',
    altText: '',
    caption: ''
  }, {
    src: '../img/wireframes/4a_leagueStats_SpaceGrey.png',
    altText: '',
    caption: ''
  }, {
    src: '../img/wireframes/5_teams_Grey.png',
    altText: '',
    caption: ''
  }, {
    src: '../img/wireframes/6_profile_Gold.png',
    altText: '',
    caption: ''
  }, {
    src: '../img/wireframes/7_requests_SpaceGrey.png',
    altText: '',
    caption: ''
  }
];

class Wip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating)
      return;
    const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({activeIndex: nextIndex});
  }

  previous() {
    if (this.animating)
      return;
    const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
    this.setState({activeIndex: nextIndex});
  }

  goToIndex(newIndex) {
    if (this.animating)
      return;
    this.setState({activeIndex: newIndex});
  }

  render() {
    const {activeIndex} = this.state;
    const slides = items.map((item) => {
      return (<CarouselItem onExiting={this.onExiting} onExited={this.onExited} key={item.src}>
        <img className="d-block" src={item.src} alt={item.altText}/>
        <CarouselCaption captionText={item.caption} captionHeader={item.caption}/>
      </CarouselItem>);
    });

    return (
      <div className="app flex-row align-items-center" align="center">
        <Container>
          <div>
            <h3 className="display-4">CricketSB</h3>
            <h3>THE CRICKET SCOREBOOK</h3>
            <p>An app for all the cricket enthusiasts</p>
          </div>
          <section>
            <div className="clearfix">
              <Carousel activeIndex={activeIndex} next={this.next} previous={this.previous}>
                <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={this.goToIndex}/>
                {slides}<CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous}/>
                <CarouselControl direction="next" directionText="Next" onClickHandler={this.next}/>
              </Carousel>
              <br></br>
            </div>
          </section>
          <section>
            <div className="div-container">
              <div>
                <a href="https://itunes.apple.com/us/app/cricketsb/id1292545937?mt=8">
                  <img className="round-corner appIconImgPadding" src="https://is2-ssl.mzstatic.com/image/thumb/Purple118/v4/95/82/3d/95823d24-8ef9-5e3d-43a5-4ebf5dd2eb3e/source/60x60bb.jpg" alt="CricketSB (The Cricket Scorebook) app is an app for all the Cricket enthusiasts"/>
                </a>
                <h5 className="appNameFont">CricketSB</h5>
              </div>
              <div>
                <p><b>Available on</b>
                <br/><a className="appStore" href="https://itunes.apple.com/us/app/cricketsb/id1292545937?mt=8"></a>
                <br/><small className="text-primary">(We are working to bring this on Android as well.)</small></p>
              </div>
            </div>
          </section>
          <br></br>
          <section>
            <hr className="my-2"/>
            <div>
              <div>
                <h3> What is it about? </h3>
                <p>CricketSB (The Cricket Scorebook) app is an app for all the Cricket enthusiasts. This app as of now can help you with following:</p>
                <div align="left">
                  <ol>
                    <li>Create Profile, Groups, Teams and much more.</li>
                    <li>Organize/participate in Leagues/Series/Tournaments.</li>
                    <li>Schedule Matches/Games.</li>
                    <li>Score Matches, track match progress, individual player contributions etc.</li>
                    <li>Automatic Match Score publishing to Individual Player's profile.</li>
                    <li>Checkout games/matches which your friends are playing.</li>
                    <li>Send requests to players for checking availability for a particular game on a particular day and much more.</li>
                  </ol>
                </div>
                <p>This app is still in beta and lot more features are being worked on. Stay tuned. Keep your app updated to receive the latest features.</p>
              </div>
            </div>
            <hr className="my-2"/>
            <h5>For any queries or support, please contact us at</h5>
            <p><a href="contact@cricketsb.com">contact@cricketsb.com</a>
            </p>
          </section>
          <div className="clearfix">
            <p className="text-muted">The website is under development.</p>
          </div>
          <hr className="my-2"/>
          <footer>
            <span>&copy; 2018 RKG APPS</span>
          </footer>
        </Container>
      </div>
    )
  }
}

export default Wip;



// WEBPACK FOOTER //
// ./src/views/Pages/Wip/Wip.js